import axios from "@/plugins/axios/researchApi";

export default {
  GET_AD_CONFIGS: async ({ commit, getters }) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
        user: getters.getCurrentUser?.userId ?? "",
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .get("adsConfig/allAdsConfig", config)
        .then((res) => {
          commit("SET_LOADER", false);
          resolve(res.data.ads_config || res.data.adConfigs || []);
          console.log(res);
        })
        .catch((err) => {
          reject(err);
          commit("SET_LOADER", false);
          commit("SET_ERROR", true);
          commit("SNACKBAR", {
            snackbar: true,
            message:
              err.response?.data?.message || "Failed to load ad configurations",
            type: "error",
          });
        });
    });
  },

  SINGLE_AD_CONFIG: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
        user: getters.getCurrentUser?.userId ?? "",
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .get(`adsConfig/singleAdsConfig/${payload}`, config)
        .then((res) => {
          commit("SET_LOADER", false);
          resolve(res.data.adConfig || res.data.ads_config);
        })
        .catch((err) => {
          reject(err);
          commit("SET_LOADER", false);
          commit("SET_ERROR", true);
          commit("SNACKBAR", {
            snackbar: true,
            message:
              err.response?.data?.message || "Failed to load ad configuration",
            type: "error",
          });
        });
    });
  },

  CREATE_AD_CONFIG: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.post(
        "adsConfig/createAdsConfig",
        payload,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          response.data.message || "Ad configuration created successfully",
        type: "success",
      });
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to create ad configuration",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },

  UPDATE_AD_CONFIG: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.put(
        `adsConfig/updateAdsConfig/${payload.id}`,
        payload,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          response.data.message || "Ad configuration updated successfully",
        type: "success",
      });
      console.log(response);
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to update ad configuration",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },

  DELETE_AD_CONFIG: async ({ commit, getters }, payload) => {
    commit("SET_ERROR", false);
    commit("SET_LOADER", true);
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getters.getToken,
      },
    };
    try {
      let response = await axios.delete(
        `adsConfig/deleteAdsConfig/${payload.id}`,
        config
      );
      commit("SET_LOADER", false);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          response.data.message || "Ad configuration deleted successfully",
        type: "success",
      });
      console.log(response);
      return response.data;
    } catch (error) {
      commit("SET_LOADER", false);
      commit("SET_ERROR", true);
      commit("SNACKBAR", {
        snackbar: true,
        message:
          error.response?.data?.message || "Failed to delete ad configuration",
        type: "error",
      });
      console.log(error);
      throw error;
    }
  },
};
